import {Component, OnInit} from "@angular/core";
import {UserService} from "../../services/users.service";
import {Router} from "@angular/router";
import {Auth2Service} from "../../../../services/auth2.service";
import {HttpErrorResponse} from "@angular/common/http";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-successful-payment-method-saved',
  templateUrl: './successful-payment-method-saved.component.html',
  styleUrls: ['./successful-payment-method-saved.component.scss'],
  standalone: false
})
export class SuccessfulPaymentMethodSavedComponent implements OnInit {
  breadCrumbs = [
    { iconClass: 'bi-house', path: 'app/users/dashboard'},
    { label: 'Dashboard', path: 'app/users/dashboard'},
    { label: 'Successful Payment Method Saved'}
  ];

  showMessages = false;
  messages: any[] = [];
  username: string = '';

  pageErrorMessages: any[] = [];
  showPageErrorMessages: boolean = false;
  pageSuccessMessages: any[] = [];
  showSuccessMessages: boolean = false;
  showPageSuccessMessages: boolean = false;

  pageName = 'Successful Payment Method Saved';

  constructor(private userService: UserService,
              private routerChild: Router,
              private auth2ServiceChild: Auth2Service,
              private titleService: Title) {
    this.titleService.setTitle("Scalanthropy Successful Payment Method Saved");
  }

  showSuccessMessagesToUser(delayMs: number = 10000): void {
    this.showSuccessMessages = true;
    const counterFn = () => {
      this.showSuccessMessages = false;
    }
    setTimeout(counterFn, delayMs);
  }

  showPageSuccessMessagesToUser(delayMs: number = 10000): void {
    this.showPageSuccessMessages = true;
    const counterFn = () => {
      this.showPageSuccessMessages = false;
    }
    setTimeout(counterFn, delayMs);
  }

  showPageErrorMessagesToUser(delayMs: number = 10000): void {
    this.showPageErrorMessages = true;
    const counterFn = () => {
      this.showPageErrorMessages = false;
    }
    setTimeout(counterFn, delayMs);
  }

  ngOnInit() {
    this.pageErrorMessages = [];
    this.username = this.auth2ServiceChild.getUsername();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    this.userService.setUserDefaultPayment(this.username).subscribe(
      (result: any) => {
        if (result && result.body) {
          this.pageSuccessMessages.push({
              field: 'User Default Payment Method Success',
              detail: 'User Payment Method set as default successfully.',
              severity: 'error'
            });
          this.showPageSuccessMessagesToUser();
        }
      },(error: HttpErrorResponse) => {
        this.pageErrorMessages.push({
          field: 'User Default Payment Method Error',
          detail: 'User Payment Method failed to set as default.',
          severity: 'error'
          });
        this.showPageErrorMessagesToUser();
      }
    );
    const counterFn = () => {
      this.routerChild.navigateByUrl('app/users/dashboard');
    }
    setTimeout(counterFn, 10000);
  }

  onGoToDashboard(): void {
    this.routerChild.navigateByUrl('app/users/dashboard');
  }
}
